"use strict";
//@ts-nocheck
/**
 * Handles foldouts
 *
 * @namespace
 * @memberOf txGs1Base
 * @public
 */
Object.defineProperty(exports, "__esModule", { value: true });
const _main_1 = require("./_main");
_main_1.txGs1Base.foldout = {
    /*
     * binds click toggle function to foldout-toggles
     */
    bindHandler: function () {
        $('[data-toggle="foldout"]').on('click', function () {
            var $foldoutContainer = $(this).parent(".btn-group");
            // Close open foldouts, but not the one belonging to the clicked button, we will handle this one later
            $('.js-open.foldout', $foldoutContainer).not('#' + $(this).attr("data-toggle-id")).removeClass('js-open');
            // Switch classes, visibility is controlled by CSS
            if ($(this).attr("data-toggle-id").length > 0) {
                var $foldout = $("#" + $(this).attr("data-toggle-id"));
                if ($foldout.length > 0) {
                    // Move targeted element, if it is not already in the .btn-group wrapper
                    if ($foldout.parent(".btn-group").length === 0) {
                        $foldout.addClass('foldout').appendTo($foldoutContainer);
                    }
                    $foldout.toggleClass('js-open');
                    // Put cursor in search field, if the search foldout is toggled - GSONE-1719
                    if ($(this).attr("data-toggle-id") === 'search_foldout') {
                        $('#tx_solr_search').focus();
                    }
                }
            }
        });
    },
    initialize: function () {
        'use strict';
        _main_1.txGs1Base.foldout.bindHandler();
    }
};
exports.default = {};
